import { render, staticRenderFns } from "./playbackSettings.vue?vue&type=template&id=2bd5823e"
import script from "./playbackSettings.vue?vue&type=script&lang=js"
export * from "./playbackSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports